const carouselItems = [
  {
    title: '斗破苍穹',
    tag: '热血',
    desc: '天才少年萧炎，逆境重生踏上巅峰之路',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20illustration%20of%20a%20young%20warrior%20in%20martial%20arts%20pose%20with%20flaming%20energy%20effects%2C%20dramatic%20action%20scene%20with%20warm%20orange%20and%20red%20color%20palette%2C%20manga%20panel%20composition%20style%2C%20intense%20battle%20atmosphere%2C%20clean%20cream%20background%20with%20speed%20lines%2C%20high%20quality%20anime%20illustration&width=800&height=500&seq=carousel-manga-01&orientation=landscape',
    alt: '斗破苍穹热血漫画',
  },
  {
    title: '狐妖小红娘',
    tag: '恋爱',
    desc: '跨越千年的爱恋故事，情缘未了再续前缘',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20Japanese%20manga%20style%20illustration%20of%20a%20beautiful%20fox%20spirit%20girl%20with%20flowing%20hair%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20peach%20color%20tones%2C%20dreamy%20atmosphere%20with%20floating%20petals%2C%20manga%20art%20style%20with%20delicate%20linework%2C%20gentle%20warm%20lighting%2C%20clean%20cream%20background&width=800&height=500&seq=carousel-manga-02&orientation=landscape',
    alt: '狐妖小红娘恋爱漫画',
  },
  {
    title: '一人之下',
    tag: '奇幻',
    desc: '平凡少年意外觉醒异人血脉，开启非凡冒险',
    img: 'https://readdy.ai/api/search-image?query=A%20supernatural%20manga%20style%20illustration%20of%20a%20young%20man%20with%20mystical%20energy%20surrounding%20him%20in%20an%20urban%20setting%2C%20Chinese%20martial%20arts%20and%20modern%20elements%20blend%2C%20dramatic%20lighting%20with%20warm%20amber%20and%20gold%20accents%2C%20manga%20composition%20style%2C%20clean%20cream%20background%20with%20subtle%20urban%20textures&width=800&height=500&seq=carousel-manga-03&orientation=landscape',
    alt: '一人之下奇幻漫画',
  },
  {
    title: '名侦探柯南',
    tag: '悬疑',
    desc: '真相只有一个，天才侦探破解重重谜案',
    img: 'https://readdy.ai/api/search-image?query=A%20mystery%20themed%20manga%20style%20illustration%20of%20a%20young%20detective%20with%20a%20magnifying%20glass%20in%20a%20dramatic%20pose%2C%20dark%20and%20warm%20color%20scheme%20with%20pools%20of%20light%2C%20mysterious%20atmosphere%20with%20silhouettes%2C%20manga%20panel%20composition%2C%20clean%20cream%20background%20with%20subtle%20mystery%20elements&width=800&height=500&seq=carousel-manga-04&orientation=landscape',
    alt: '名侦探柯南悬疑漫画',
  },
  {
    title: '海贼王',
    tag: '热血',
    desc: '为了梦想与伙伴，踏上伟大航路的冒险之旅',
    img: 'https://readdy.ai/api/search-image?query=A%20grand%20adventure%20manga%20style%20illustration%20of%20pirates%20on%20a%20ship%20sailing%20toward%20the%20horizon%2C%20warm%20golden%20sunset%20colors%2C%20dramatic%20clouds%20and%20ocean%20waves%2C%20epic%20scale%20composition%2C%20manga%20art%20style%20with%20bold%20lines%2C%20clean%20cream%20background%20transitioning%20to%20sea&width=800&height=500&seq=carousel-manga-05&orientation=landscape',
    alt: '海贼王热血冒险漫画',
  },
  {
    title: '鬼灭之刃',
    tag: '热血',
    desc: '少年剑士与鬼之始祖的殊死对决，斩断命运',
    img: 'https://readdy.ai/api/search-image?query=A%20stunning%20manga%20style%20illustration%20of%20a%20young%20swordsman%20with%20a%20katana%20in%20a%20dramatic%20battle%20stance%2C%20flowing%20water%20breathing%20effects%20in%20blue%20and%20warm%20amber%20contrast%2C%20intense%20action%20composition%2C%20traditional%20Japanese%20elements%2C%20manga%20art%20style%2C%20clean%20cream%20background%20with%20dynamic%20speed%20lines&width=800&height=500&seq=carousel-manga-06&orientation=landscape',
    alt: '鬼灭之刃热血漫画',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">编辑精选<strong>免费完整版漫画</strong>，口碑与人气双重认证的必看之作</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}